export default function () {
  const footer = document.getElementById('js-footer')
  const activeClass = 'is-intersecting'
  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) {
      footer.classList.add(activeClass)
    } else {
      footer.classList.remove(activeClass)
    }
  }, {
    rootMargin: "-50% 0%"
  })
  observer.observe(footer)

  const randomFootprints = [...footer.querySelectorAll('.js-footprint-random')]
  randomFootprints.forEach((target, index) => {
    setInterval(() => {
      target.style.left = Math.floor(Math.random() * 800) / 10 + 10 + '%'
      target.style.top = Math.floor(Math.random() * 800) / 10 + 10 + '%'
      target.style.transform = `rotate(${Math.floor(Math.random() * 360)}deg)`
      target.classList.add('is-active')

      setTimeout(() => {
        target.classList.remove('is-active')
      }, 2000);
    }, 4000 + index * 400);
  })
}
